module.exports = __webpack_public_path__ + "static/media/general.1c6a3e60.webp";